import React, { useState } from 'react';
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import { useProductStore } from 'src/hooks/product';
import Helper from 'src/helper/Helper';
import { __remove, __set } from 'src/store/axios_indicator';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import System from 'src/helper/system';

const SendEmailOfReportError = (props) => {
    const { SetStatus, data } = props;
    const [formData, setFormData] = useState({ typeofError: [], information: '', name: '', email: '' })
    const [errors, setErrors] = useState({})
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { send_Report_Error_Email }, { }] = useProductStore();
    const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const partNo = data?.productDetail?.ERPMFRPartNumber ? data?.productDetail.ERPMFRPartNumber : '-'
    const manufacturerName = data?.productDetail?.ManufacturerName ? data?.productDetail.ManufacturerName : '-'
    const productDescription = data?.productDetail?.ShortDescription ? data?.productDetail.ShortDescription : '-'
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { translation:t } = System;

    const handleOnChange = (name, value, key) => {
        if (Object.keys(errors)?.length > 0) {
            delete errors[name]
        }
        if (name === 'typeofError') {
            setFormData({ ...formData, 'typeofError': value ? [...formData.typeofError, key] : formData.typeofError.filter(ele => ele !== key) })
        } else {
            setFormData({ ...formData, [name]: value })
        }
    }

    const onValidateData = () => {
        let validationModal = {}
        Helper.valueIsNotNull(formData.typeofError) ? "" : validationModal.typeofError = t('errorTypeSelectionValidation');
        Helper.valueIsNotNull(formData.information) ? (formData.information?.length > 999 ? validationModal.information = t('additionalInfoValidation') : '') : '';
        Helper.valueIsNotNull(formData.name) ? "" : validationModal.name = "Please enter a valid Name";
        !Helper.valueIsNotNull(formData.email) || !Helper.validateRegex(formData.email, emailPattern) ? validationModal.email = t('emailValidation') : '';
        setErrors({ ...validationModal })
        return Object.keys(validationModal).length <= 0;
    }

    const onSubmit = async () => {
        const valid = onValidateData()
        if (valid) {
            const reqBody = {
                "partNo": partNo,
                "manufacturerName": manufacturerName,
                "productDescription": productDescription,
                "typeofError": formData.typeofError,
                "additionalInformation": formData.information,
                "name": formData.name,
                "email": formData.email
            }
            __set('SEND_REPORT_ERROR_EMAIL_API_CALL')
            const res = await send_Report_Error_Email(reqBody);
            __remove('SEND_REPORT_ERROR_EMAIL_API_CALL')
            if (res.isSuccessFull) {
                system_alert_indicator({
                    name: 'productDetailsErr',
                    message: t('reportSubmittedInfoAlert'),
                    type: "success"
                })
                
            } else {
                system_alert_indicator({
                    name: 'productDetailsErr',
                    message: res.message ||  t('somethingWentWrong'),
                    type: "danger"
                })
                
            }
            SetStatus(false)
        }
    }

    const TypeOfError = [
        { key: t('productDescriptionAttribute') },
        { key: t('mageSchematic') },
        { key: t('datasheet') },
        { key: t('searchNavigation') },
        { key:t('alternativeSubstitutesProducts') },
        { key: t('pricing')  },
        { key: t('other')  }
    ]

    return (
        <div className="avnet-modal modal-630" id="sendMailModal">
            <div className="avnet-modal-inner">
                <button type="button" className="close" data-dismiss="modal"
                    onClick={() => SetStatus(false)}> ×
                </button>
                <div className="modal-header justify-content-center">
                    <h2 className="pcn-modal-heading">{t('reportError')}</h2>
                </div>
                <div className="modal-body">
                    <form id="hook-form">
                        <p className="mb-1 font-14">{t('feedBackThankYouMessage')}</p>
                        <div className="label-value mb-3">
                            <div className="label-value-item">
                                <label>{t('partNo')}.</label>
                                <span>{partNo}</span>
                            </div>
                            <div className="label-value-item">
                                <label>{t('manufacturerName')}:</label>
                                <span>{manufacturerName}</span>
                            </div>
                            <div className="label-value-item">
                                <label>{t('productDescription')}:</label>
                                <span>{productDescription}</span>
                            </div>
                        </div>
                        <div className="row m-0">
                            <div className="col-12">
                                <div className="form-group">
                                    <label htmlFor="email"><b>{t('typeofError')}</b> <span
                                        className="mandatory">*</span></label>
                                    {TypeOfError.map((obj, idx) => (
                                        <div className="form-check" key={idx}>
                                            <input type="checkbox" className="form-check-input" id="customCheck1"
                                                name="typeofError" value={obj.key}
                                                onChange={({ target: { checked } }) => handleOnChange('typeofError', checked, obj.key)}
                                            />
                                            <label className="form-check-label" htmlFor="customCheck1">{obj.key}</label>
                                        </div>
                                    ))}
                                    <p className="error">{errors?.typeofError}</p>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="Information">{t('additionalInformationOptional')}</label>
                                        <textarea name="information" rows={8} cols={60}
                                            className="avnet-textBox form-control h-auto"
                                            placeholder="Comments" id="Comments"
                                            onChange={({ target: { value } }) => handleOnChange('information', value)}
                                        />
                                        <p className="error">{errors?.information}</p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="name">{t('name')} <span className="mandatory">*</span></label>
                                    <input type="text" name="name" aria-label="Share via Name" id="name"
                                        size={60} className="avnet-textBox form-control" placeholder="Name"
                                        onChange={({ target: { value } }) => handleOnChange('name', value)}
                                    />
                                    <p className="error">{errors?.name}</p>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">{t('email')} <span className="mandatory">*</span></label>
                                    <input type="text" name="email" aria-label="Share via email" id="email"
                                        size={60} className="avnet-textBox form-control h-auto"
                                        placeholder="Email"
                                        onChange={({ target: { value } }) => handleOnChange('email', value)}
                                    />
                                    <p className="error">{errors?.email}</p>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                {__check(['SEND_REPORT_ERROR_EMAIL_API_CALL']).render}
                {!__check(['SEND_REPORT_ERROR_EMAIL_API_CALL']).status &&
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary minw-auto" data-bs-toggle="modal"
                                data-bs-target="#ReportModal"
                                onClick={() => SetStatus(false)}> {t('cancel')}
                            </button>
                            <button type="button" className="bs5 btn btn-primary minw-auto" data-bs-toggle="modal"
                                data-bs-target="#ReportModal" form="hook-form" onClick={() => onSubmit()}>
                                {t('submit')}
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default SendEmailOfReportError;